import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@mui/material';

import { PaymentIcon } from './styles';
import { Container, Content, IconContainer, Label, Value } from '../PlanField/styles';

const Props = {
  title: PropTypes.string.isRequired,
  onUpdateClick: PropTypes.func,
};

const card = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.666 5.3335H5.33268C3.85935 5.3335 2.67935 6.52683 2.67935 8.00016L2.66602 24.0002C2.66602 25.4735 3.85935 26.6668 5.33268 26.6668H26.666C28.1393 26.6668 29.3327 25.4735 29.3327 24.0002V8.00016C29.3327 6.52683 28.1393 5.3335 26.666 5.3335ZM26.666 24.0002H5.33268V16.0002H26.666V24.0002ZM26.666 10.6668H5.33268V8.00016H26.666V10.6668Z"
      fill="#212121"
    />
  </svg>
);

export default function PlanPaymentMethod({ title, onUpdateClick }) {
  return (
    <Container>
      <IconContainer>
        <PaymentIcon>{card}</PaymentIcon>
      </IconContainer>
      <Content>
        <Label>Payment Method</Label>
        <Value>{title}</Value>

        {onUpdateClick && (
          <Value>
            <Link onClick={onUpdateClick} underline="hover">
              Update card
            </Link>
          </Value>
        )}
      </Content>
    </Container>
  );
}

PlanPaymentMethod.propTypes = Props;
